import { render, staticRenderFns } from "./invest_mark.vue?vue&type=template&id=35e4ab10&scoped=true&"
import script from "./invest_mark.vue?vue&type=script&lang=js&"
export * from "./invest_mark.vue?vue&type=script&lang=js&"
import style0 from "./invest_mark.vue?vue&type=style&index=0&id=35e4ab10&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35e4ab10",
  null
  
)

export default component.exports